export enum WorkOrderBadge {
  HOT = 'HOT',
  PREMIUM = 'PREMIUM',
  REFILE = 'REFILE',
}

export const workOrderBadgeDescription = 'Work Order badge. Example: Hot';
